import ENDPOINTS from 'api/endpoints';
import { doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  ApiConfigCreateRequest,
  ApiConfigMetrics,
  ApiConfigPatchRequest,
  ApiConfigResponse,
} from './types';

export const getApiConfigMetrics = (accountId: string) => {
  return doGet<ApiConfigMetrics>(
    generateNextPath(`${ENDPOINTS.API_CONFIGS}/metrics`, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );
};

export const getApiConfig = (accountId: string) => {
  return doGet<ApiConfigResponse>(
    generateNextPath(ENDPOINTS.API_CONFIGS, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );
};

export const patchApiConfig = (
  accountId: string,
  body: ApiConfigPatchRequest,
) => {
  return doPatch<ApiConfigResponse>(
    generateNextPath(ENDPOINTS.API_CONFIGS, { accountId }),
    LOGGER_TYPE.JUPITER,
    body,
    { prefix: 'nebula' },
  );
};

export const postApiConfig = (
  accountId: string,
  body: ApiConfigCreateRequest,
) => {
  return doPost<ApiConfigResponse>(
    generateNextPath(ENDPOINTS.API_CONFIGS, { accountId }),
    LOGGER_TYPE.JUPITER,
    body,
    { prefix: 'nebula' },
  );
};
